import axios from "axios";

const baseBasicAuthClient = axios.create({
  baseURL: process.env.REACT_APP_R_MOBILE, // 서버
  timeout: 30 * 1000,
  auth: {
    username: "cloud",
    password: "cloud!@",
  },
});

baseBasicAuthClient.interceptors.request.use(function (config) {
  return config;
});

baseBasicAuthClient.interceptors.response.use(
  function (response) {
    return response;
  },

  function (error) {
    return Promise.reject(error);
  }
);

export default baseBasicAuthClient;
